import { styled } from "@mui/material";
export const StyledTypography = styled("div")(({ theme }) => ({
  justifyContent: "center",
  alignContent: "center",
  textAlign: "center",

  fontFamily: "'Montserrat', sans-serif",
  fontSize: 19,
  fontWeight: 400,
}));
